import React, { useState, useEffect } from 'react';
import LeadService from './LeadService';
import { Link } from 'react-router-dom';
import { Button, Modal, Dropdown } from 'react-bootstrap';
import Alert from 'react-bootstrap/Alert';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import filterFieldsForList from '../common/functions/filterFieldsForList';
import filterDataForList from '../common/functions/filterDataForList';
import schema from './jsonSchema';
import AdvanceList from '../common/AdvanceList';
import useHeaderGenerator from '../common/functions/useHeaderGenerator';
import { useNavigate } from 'react-router-dom';
import { utils, writeFile } from 'xlsx';

const LeadList = () => {
  const [data, setData] = useState();
  const [columns, setColumns] = useState([]);
  const [error, setError] = useState('');
  const [noDataToShow, setNoDataToShow] = useState(true);
  const [leadSources, setLeadSources] = useState();
  const [exportToExcelData, setExportToExcelData] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const navigate = useNavigate();

  const handleShowDeleteModal = lead => {
    setSelectedLead(lead);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setSelectedLead(null);
    setShowDeleteModal(false);
  };

  const handleDelete = async () => {
    if (selectedLead) {
      await LeadService.deleteLead(selectedLead.identifier);
      // Refresh the data
      setNoDataToShow(true);
      handleCloseDeleteModal();
    }
  };

  const handleEdit = identifier => {
    navigate(`/app/leads/${identifier}`);
  };

  const transformData = (attr, item) => {
    console.log(attr);
    if (attr == 'email') {
      const url = '/app/leads/' + item['identifier'];
      return <Link to={url}>{item[attr]}</Link>;
    }
    if (attr == 'identifier') {
      return (
        <Dropdown>
          <Dropdown.Toggle variant="link" size="sm" className="px-2">
            <FontAwesomeIcon icon="ellipsis-h" />
          </Dropdown.Toggle>
          <Dropdown.Menu>
            <Dropdown.Item onClick={() => handleEdit(item.identifier)}>
              <FontAwesomeIcon icon="edit" className="me-2" />
              Edit
            </Dropdown.Item>
            <Dropdown.Item
              onClick={() => handleShowDeleteModal(item)}
              className="text-danger"
            >
              <FontAwesomeIcon icon="trash" className="me-2" />
              Delete
            </Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>
      );
    }
    return item[attr];
  };
  useEffect(() => {
    const jsonSchema = schema;
    const fieldsForList = filterFieldsForList(jsonSchema);
    // Add actions column
    const columnsWithActions = [
      ...fieldsForList,
      {
        accessor: 'identifier',
        Header: 'Actions',
        disableSortBy: true
      }
    ];
    setColumns(columnsWithActions);
    const attributesToInclude = ['email', 'firstName', 'lastName', 'phoneNumber', 'location', 'leadSource', 'comments', 'identifier'];
    LeadService.retrieveAllLeadByProfile()
      .then(data => {
        console.log('Data', data);
        setData(
          filterDataForList(
            data,
            attributesToInclude,
            transformData
          )
        );
        const exportToExcelData = data.map(x => ({
          identifier: x.identifier,
          'first name': x.firstName,
          'last name': x.lastName,
          email: x.email,
          phone: x.phoneNumber,
          location: x.location,
          source: x.leadSource,
          comments: x.comments
        }));
        setExportToExcelData(exportToExcelData);

        setNoDataToShow(!data.length > 0);
      })
      .catch(error => setError({ error: error.message }));

    const sources = [
      {
        label: 'Website traffic',
        value: 'Website traffic'
      },
      {
        label: 'Email marketing',
        value: 'Email marketing'
      },
      {
        label: 'Content marketing',
        value: 'Content marketing'
      },
      {
        label: 'Social media',
        value: 'Social media'
      },

      {
        label: 'Trade shows and events',
        value: 'Trade shows and events'
      },
      {
        label: 'Partnerships and referrals',
        value: 'Partnerships and referrals'
      },
      {
        label: 'Cold calling',
        value: 'Cold calling'
      },
      {
        label: 'Direct mail',
        value: 'Direct mail'
      }
    ];
    setLeadSources(sources);
    console.log(leadSources);
  }, [noDataToShow]);
  const buttonsConf = [
    {
      name: 'New Lead',
      type: 'submit',
      variant: 'info',
      icon: 'plus',
      onClick: () => {
        console.log('Create a new Lead');
        navigate('/app/leads/create-form');
      }
    },
    {
      name: 'Import Leads',
      type: 'submit',
      icon: 'users',
      variant: 'primary',
      onClick: () => {
        console.log('Import leads');
        navigate('/app/leads/import');
      }
    },
    {
      name: 'Export to Excel',
      type: 'button',
      icon: 'rocket',
      variant: 'outline-success',
      onClick: () => {
        const data = exportToExcelData;
        const name = 'Leads';
        let wb = utils.book_new();
        let ws = utils.json_to_sheet(data);
        utils.book_append_sheet(wb, ws, name);
        const fileName = name + '.xlsx';
        writeFile(wb, fileName);
      }
    }
  ];
  const leadsDescription =
    'Capture and nurture potential candidates with our powerful Leads Management module. Streamline the process of tracking and managing candidate leads from various sources, ensuring that no opportunity is missed. This module allows you to categorize leads, monitor their progress through the recruitment pipeline, and maintain clear communication with prospective talent. By integrating seamlessly with your recruitment workflows, our Leads Management module helps you build a strong talent pipeline and make data-driven decisions to enhance your hiring strategy.';
  const headerGenerated = useHeaderGenerator(
    'Leads Managment',
    leadsDescription,
    buttonsConf
  );
  return (
    <>
      {error}
      {headerGenerated}
      {noDataToShow && (
        <Alert key="warning" variant="warning">
          There's not any Lead to show. Let's create a new one!
        </Alert>
      )}
      {data && !noDataToShow && (
        <AdvanceList
          columns={columns}
          data={data}
          searchBox={true}
          newObject={{
            url: '/app/leads/create-form',
            title: 'Create a new Lead'
          }}
        />
      )}

      <Modal show={showDeleteModal} onHide={handleCloseDeleteModal}>
        <Modal.Header closeButton>
          <Modal.Title>Confirm Deletion</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete the lead "
          {selectedLead?.firstName} {selectedLead?.lastName}"?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseDeleteModal}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default LeadList;
